import PizzaBuilderDesktop from './PizzaBuilderDesktop';

export default PizzaBuilderDesktop;
